<template>
  <div>
    <div class="corporation bacgk">
      <img :src="enterpriseInfo.logo? enterpriseInfo.logo : require('../../../../assets/image/fuwu.jpg')" alt="" />
      <h2>{{ enterpriseInfo.name }}</h2>
      <div class="corporation_mesg flex-item-center">
        <div style="width:100px;display:flex">
          <img src="@/assets/supplyHome/fuwu.png" alt="" class="img_icon">
          <p>在售服务：</p>
        </div>
        <span>{{ enterpriseInfo.serviceCount }}个</span>
      </div>
      <div class="corporation_mesg flex-item-center">
        <div style="width:100px;display:flex">
          <img src="@/assets/supplyHome/xiaoshou.png" alt="" class="img_icon">
          <p>累计销售：</p>
        </div>
        <span>{{ enterpriseInfo.orderNum }}笔</span>
      </div>
      <div class="corporation_mesg flex-item-center">
        <div style="width:100px;display:flex">
          <img src="@/assets/supplyHome/pingjia.png" alt="" class="img_icon">
          <p>综合好评：</p>
        </div>
        <span>{{haoping}}%</span>
      </div>
      <el-button class="btn" @click="getStort" icon="el-icon-s-shop">进店看看</el-button>
    </div>
    <div class="bacgk">
      <div class="titile titile_flex">
        <h4 class="">最新服务</h4>
        <p @click="serviceHot('random')">
          <i class="el-icon-refresh"></i>
          换一批
        </p>
      </div>
      <div class="right">
        <div
          class="right_box"
          v-for="(item, index) in demandList"
          :key="index"
          @click="getNewsServer(item.id)"
        >
          <img :src="item.mainPhotoUrl" alt="">
          <div>
            <p class="right_box_title">{{ item.title }}</p>
            <p class="right_box_num">服务分类：{{ item.type }}</p>
            <span class="red">￥{{ item.money }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {serviceListHot} from "../../../../utils/interface";

export default {
  props:{
    haoping:String
  },
  data() {
    return {
      demandList: [],
      enterpriseInfo:{},
      serviceId:'',
    };
  },
  created() {
    this.init();
  },
  methods: {
    init(item,serviceId) {
      console.log("---------item-----------",item)
     this.enterpriseInfo = item;
      this.serviceId = serviceId;
      this.serviceHot('new');
    },
    serviceHot(type) {
      serviceListHot({id:this.serviceId,type:type}).then((res) => {
        this.demandList = res;
      });
    },
    getStort() {
      let routeData = this.$router.resolve({
        name: "printServiceIndex",
        params: { enterPriseId: this.enterpriseInfo.enterpriseUuid },
      });
      window.open(routeData.href, "_blank");
    },
    getNewsServer(uuid) {
      let routeData = this.$router.resolve({
        path: `/serviceDetails`,
        query: { uuid: uuid },
      });
      window.open(routeData.href, "_blank");
      // this.$router.push({name:"serviceDetails",params:{uuid:uuid}});
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../style/index.less";
.titile_flex {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  p {
    font-size: 12px;
    cursor: pointer;
    color: #169999;
    margin-right: 15px;
  }
}
.grap {
  color: rgba(0, 0, 0, 0.5);
}
.right {
  .right_box {
    color: #333;
    font-size: 14px;
    padding-bottom: 15px;
    cursor: pointer;
    display: flex;
    .right_box_title {
      font-size: 14px;
      color: #333333;
      font-size: 16px;
      margin-bottom: 2px;
        display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    }
    .right_box_num {
      font-size: 12px;
      color: #999999;
      margin-bottom: 8px;
    }
    .red {
      font-size: 14px;
      color: #DE3131;
    }
    img {
      width: 116px;
      height: 65px;
      background: #CCCCCC;
      border-radius: 4px 4px 4px 4px;
      margin-right: 12px;
      flex-shrink: 0;
    }
  }
}
.corporation {
  padding: 22px 45px 33px;
  text-align: center;
  margin-bottom: 20px;
  height: 345px;
  box-sizing: border-box;
  img {
    width: 130px;
    height: 100px;
    margin-bottom: 13px;
  }
  h2 {
    font-size: 16px;
    color: #333333;
    margin-bottom: 16px;
  }
  .corporation_mesg {
    justify-content: space-between;
    font-size: 14px;
    color: #333;
    margin-bottom: 9px;
    letter-spacing: 0.1em;
    padding: 0 15px;
    .img_icon {
      width: 16px;
      height: 16px;
      margin-bottom: 0;
      margin-right: 5px;
    }
    span {
      // margin-left: 23px;
      font-size: 14px;
      color: #169999;
    }
  }
  .btn {
    margin-top: 10px;
    background: rgba(22, 153, 153, 0.11);
    border-radius: 8px;
    font-size: 14px;
    color: #169999;
    border: none;
    width: 125px;
    height: 43px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/supplyHome/components/details/serverDetailsRight.vue